
const fields = [
    {
        inputName: "Id",
        inputType: "hidden",
        label: null,
        model: "Id",
        required: true,
        type: "input"
    },
    {
        inputName: "Name",
        inputType: "text",
        label: "Field",
        model: "Name",
        required: true,
        type: "input"
    },
    {
        inputName: "Label",
        inputType: "text",
        label: "نام",
        model: "Label",
        required: false,
        type: "input"
    },
    {
        inputName: "Value",
        inputType: "text",
        label: "مقدار",
        model: "Value",
        required: true,
        type: "input"
    }
];

export default fields;